module.exports = __webpack_public_path__ + "static/media/DOone_Practice1_icon.0f070df6.png";